// export const myAction = async ({ commit }) => {};
import { getCategoriesWP } from "@/modules/adminPanel/helpers/categoriesWordpress";

export const getCategories = async ({ commit }) => {
  const { data, status } = await getCategoriesWP();
  if (status != 200) return console.log("error");

  commit("updateCategories", data);
};
